module.exports = __webpack_public_path__ + "static/media/paper_hero_twitter_card.a346b681.jpg";